import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthServerBase } from '../utils/runtime';

const AUTH_SERVER = getAuthServerBase();

function AddServiceProfessional() {
  const [user, setUser] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : Promise.reject('Non connecté'))
      .then(data => setUser(data.user || data))
      .catch(() => {
        alert('Session expirée. Veuillez vous reconnecter.');
        window.location.href = '/';
      });
  }, []);

  useEffect(() => {
    fetch('https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/services')
      .then(res => res.json())
      .then(setServices)
      .catch(err => console.error('Erreur chargement services:', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedService || !user?.email) return;

    try {
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${user.email}`);
      const userData = await userRes.json();

      const resp = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${userData.user_id}/services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          service_id: selectedService
        })
      });

      if (resp.ok) {
        setMessage('✅ Service ajouté avec succès !');
        setTimeout(() => navigate('/professional/dashboard'), 1500);
      } else {
        const errorText = await resp.text();
        setMessage('❌ Erreur: ' + errorText);
      }
    } catch (err) {
      console.error('Erreur ajout service:', err);
      setMessage('❌ Erreur serveur.');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Ajouter un service</h2>
      {message && <p>{message}</p>}

      <form onSubmit={handleSubmit}>
        <label>
          Sélectionnez un service :
          <select value={selectedService} onChange={(e) => setSelectedService(e.target.value)} required>
            <option value="">-- Choisir un service --</option>
            {services.map(service => (
              <option key={service.service_id} value={service.service_id}>{service.name}</option>
            ))}
          </select>
        </label>

        <br /><br />
        <button type="submit" style={{ backgroundColor: '#6a1b9a', color: 'white', padding: '8px 16px', borderRadius: '4px', border: 'none' }}>
          Ajouter
        </button>
      </form>
    </div>
  );
}

export default AddServiceProfessional;
